import React from 'react';

import {
  LandingSelectedEntities,
} from '../../../components';

import './style.scss';

const ViewRecentEntitiesLarge = ({ entities, title, attr }) => {

  return (
    <LandingSelectedEntities
      type={attr.type}
      link={attr.link}
      entities={entities}
      title={title}
    />
  );
};

export default ViewRecentEntitiesLarge;
